import type { Me } from '../api';

/** Home panel inside the app shell: who you are, your tenant, your permissions. */
export function Home({ me }: { me: Me }) {
  return (
    <div className="card">
      <h1>Welcome{me.user.fullName ? `, ${me.user.fullName}` : ''}</h1>
      <p className="muted">Use the navigation to manage records. Stage 2 (Core CRM) is active.</p>
      <dl className="kv">
        <dt>User</dt>
        <dd>{me.user.email}</dd>
        <dt>Role</dt>
        <dd>
          {me.user.role.name ?? me.user.role.key} <span className="muted">({me.user.role.key})</span>
        </dd>
        <dt>Tenant</dt>
        <dd>
          {me.tenant.name} <span className="muted">· schema: {me.tenant.schema}</span>
        </dd>
      </dl>
      <h2 style={{ fontSize: '1.05rem' }}>Effective permissions</h2>
      {me.permissions.length === 0 ? (
        <p className="empty">No gated permissions for this role.</p>
      ) : (
        <div>
          {me.permissions.map((p) => (
            <span key={p} className="tag">
              {p}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
